var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportNexus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8025_24367)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.85156 17.9688V7.03125",
    stroke: "#27DEBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4766 7.03125V17.9688",
    stroke: "#27DEBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.53906 12.5V14.0625",
    stroke: "#27DEBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6641 11.7188V14.0625",
    stroke: "#27DEBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7891 10.9375V14.0625",
    stroke: "#27DEBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2578 3.90625H4.07031C3.63884 3.90625 3.28906 4.25603 3.28906 4.6875V6.25C3.28906 6.68147 3.63884 7.03125 4.07031 7.03125H21.2578C21.6893 7.03125 22.0391 6.68147 22.0391 6.25V4.6875C22.0391 4.25603 21.6893 3.90625 21.2578 3.90625Z",
    stroke: "#27DEBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6641 17.9688V21.0938",
    stroke: "#27DEBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6641 24.2188C13.527 24.2188 14.2266 23.5192 14.2266 22.6562C14.2266 21.7933 13.527 21.0938 12.6641 21.0938C11.8011 21.0938 11.1016 21.7933 11.1016 22.6562C11.1016 23.5192 11.8011 24.2188 12.6641 24.2188Z",
    stroke: "#27DEBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.28906 17.9688H22.0391",
    stroke: "#27DEBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8025_24367"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(0.164062)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportNexus);
export default __webpack_public_path__ + "static/media/report_nexus.59daf189d9740c735c035d0faff477a5.svg";
export { ForwardRef as ReactComponent };